var _a;
import * as SportType from '../../../constants/SportType';
export var FORWARD = 1;
export var BACKWARD = 2;
export var DirectionMap = (_a = {},
    _a[SportType.BASKETBALL] = BACKWARD,
    _a[SportType.ICE_HOCKEY] = BACKWARD,
    _a);
export function getDirection(sportId) {
    return DirectionMap[sportId] || FORWARD;
}



// WEBPACK FOOTER //
// ./src/components/grid/live/direction.js